export default __webpack_public_path__ + "static/media/1080-HD.00e453ed.jpg";